var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.1,377.1H10V10h367.1V377.1z M78.6,308.5h229.8V78.6H78.6V308.5L78.6,308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,132.4h122.4v122.4H132.4V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,990H10V621.8h367.1V990z M78.6,921.4h229.8v-231H78.6V921.4L78.6,921.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,745.3h122.4v121.2H132.4V745.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990,377.1H621.8V10H990V377.1z M690.4,308.5h231V78.6h-231V308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.3,132.4h121.2v122.4H745.3V132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,377.1h122.4v123.5H10V377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,500.6h122.4v121.2H254.7V500.6L254.7,500.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6,10h121.2v122.4H500.6V10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.1,254.7h123.5v122.4H377.1V254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6,866.5h121.2V990H500.6V866.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.3,866.5H990V990H745.3V866.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6,621.8h244.7v123.5H500.6V621.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.3,621.8h121.2v244.7H745.3V621.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.1,621.8H990v123.5H855.1V621.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.6,377.1h121.2v123.5H500.6V377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.8,500.6h123.5v121.2H621.8V500.6L621.8,500.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.3,377.1h121.2v123.5H745.3V377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.5,500.6H990v121.2H866.5V500.6L866.5,500.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.c5d4264e89aff462592e6aed89c18532.svg";
export { ForwardRef as ReactComponent };